import { render, staticRenderFns } from "./OrganizationalIcon.vue?vue&type=template&id=0371a654&"
import script from "./OrganizationalIcon.vue?vue&type=script&lang=js&"
export * from "./OrganizationalIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports